import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {fetchPage} from '../../../actions/page'

const mapStateToProps = ({courses: { selectedCourseCode, data }, course: { selectedCourse }, page: {previous, pathname, title, updatedAt}}) => {
  return {
    courseId: selectedCourseCode,
    admissionCategory: data[selectedCourseCode].admissionCategory,
    previous,
    pathname,
    title,
    updatedAt,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleRouteChange: slug => {
      dispatch(fetchPage(slug))
    }
  }
}

class Page extends Component {
  componentDidMount() {
    this.handleRouteChange()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname || prevProps.admissionCategory !== this.props.admissionCategory) {
      this.handleRouteChange()
    }

    if (this.props.updatedAt !== prevProps.updatedAt) {
      this.trackRouteChange()
    }
  }

  trackRouteChange = () => {
    window.dataLayer.push({
      event: 'custom.route.change',
      route: {
        current: this.props.pathname,
        previous: this.props.previous,
        title: this.props.title,
      },
      data: {
        value: undefined,
        courseId: this.props.courseId,
      },
      processId: undefined,
    })
  }

  handleRouteChange = () => {
    this.props.handleRouteChange(this.props.location.pathname)
  }

  render() {
    return this.props.children
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page))
